import React from 'react';
import { Container } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';
import { useTenant } from '../contexts/TenantContext';
import Login from './Login';
import TenantSelector from './TenantSelector';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const { selectedTenant } = useTenant();

  if (loading) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center">
        <Container className="text-center">
          <div className="spinner-border text-primary mb-3" role="status"></div>
          <div>Cargando...</div>
        </Container>
      </div>
    );
  }

  if (!user) {
    return <Login />;
  }

  if (!selectedTenant) {
    return <TenantSelector />;
  }

  return children;
};

export default ProtectedRoute;